/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {ID, KTIcon, QUERIES} from '../../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteData} from '../../core/_requests'

type Props = {
  id: ID
  title: string
}

const ActionsCell: FC<Props> = ({id, title}) => {
  const {openEditTab} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  const deleteItem = useMutation(() => deleteData(id), {
    onSuccess: () => queryClient.invalidateQueries([`${QUERIES.TICKET_LIST}-${query}`]),
  })

  const handleDelete = async () => {
    if (window.confirm(`Apakah Anda yakin ingin menghapus tiket "${title}"?`)) {
      await deleteItem.mutateAsync()
    }
  }

  return (
    <div className='d-flex justify-content-end flex-shrink-0'>
      {/* Tombol Edit */}
      <button
        title='Edit Tiket'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        onClick={() => {
          if (openEditTab) openEditTab({id, title})
        }}
      >
        <KTIcon iconName='pencil' className='fs-3' />
      </button>

      {/* Tombol Delete */}
      <button
        title='Hapus Tiket'
        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
        onClick={handleDelete}
        disabled={deleteItem.isLoading}
      >
        {deleteItem.isLoading ? (
          <span className='spinner-border spinner-border-sm align-middle'></span>
        ) : (
          <KTIcon iconName='trash' className='fs-3' />
        )}
      </button>
    </div>
  )
}

export {ActionsCell}